import { IEntity } from "./Entity";

export interface IApp03SprintEvidence extends IEntity {
    FileUniqueID?: string;
    Details?: string;
    SprintID?: number;
    DateCreated?: Date;
    AddedByUserID?: number;
    AttachmentType?: string;
}

export class App03SprintEvidence implements IApp03SprintEvidence {
    public ID: number = 0;
    public Title: string = null;
    public FileUniqueID?: string = null;
    public Details?: string = "";
    public SprintID?: number = null;
    public DateCreated?: Date = null;
    public AddedByUserID?: number = null;
    public AttachmentType?: string = null;

    constructor(sprintID: number, attachmentType: string) {
        this.SprintID = sprintID;
        this.AttachmentType = attachmentType;
    }
}